//Libs
import * as _ from 'lodash';
//Constants
import * as ACTIONS from './actionTypes';
import { NONE_DISPLAY } from './constants'
//Types
import { ChatmeterAccount, ChatmeterLocation } from './types';
import { ActionAccountAPI, ActionAccountAPISuccess, ActionGetChatmeterAccountsAPISuccess, ActionGetChatmeterLocationsAPISuccess } from './actions';

export interface ChatmeterState {
    locations: ChatmeterLocation[]
    deactivelocations: ChatmeterLocation[]
    accounts: ChatmeterAccount[]
    newaccount?: ChatmeterAccount
}

const defaultState: ChatmeterState = {
    locations:[],
    deactivelocations:[],
    accounts:[]
};

type GetChatmeterLocationsAction =  ActionGetChatmeterLocationsAPISuccess | ActionGetChatmeterAccountsAPISuccess | ActionAccountAPISuccess 

function chatmeterReducer(state: ChatmeterState = defaultState, action: GetChatmeterLocationsAction): ChatmeterState {
    switch (action.type) {
        case ACTIONS.GET_CHATMETERLOCATIONS_API_SUCCESS:
            {
                const locations = (action as ActionGetChatmeterLocationsAPISuccess).locations
                return {
                    ...state,
                    locations: locations,
                }

            }
        case ACTIONS.GET_CHATMETERDEACTIVELOCATIONS_API_SUCCESS:
            {
                const locations = (action as ActionGetChatmeterLocationsAPISuccess).locations
                return {
                    ...state,
                    deactivelocations: locations,
                }
            }
        case ACTIONS.GET_CHATMETERACCOUNTS_API_SUCCESS:
            {
                const accounts = (action as ActionGetChatmeterAccountsAPISuccess).accounts
                return {
                    ...state,
                    accounts: accounts
                }
            }        
        case ACTIONS.ADD_CHATMETERACCOUNT_API_SUCCESS:
                {
                    const account = (action as ActionAccountAPISuccess).account
                    return {
                        ...state,
                        newaccount: account
                    }
                }        


        default: {
            return {
                ...state
            }
        }
    }

}


export default chatmeterReducer